const doc = [({"da":({"js":({"super_admin":({"model_configs":({"invoice":({"total_price":"Total pris"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;